import { CommandPaletteContent } from '@/components/command-palette/CommandPaletteContent';
import { useOverlays } from '@/providers/dashboard/ShellContext';

export const CommandPalette = () => {
  const { paletteOpen } = useOverlays();

  if (!paletteOpen) return null;
  return <CommandPaletteContent />;
};
